import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import api from '../api';

export default function RatingStars({ applicationId, size = 20 }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [showComment, setShowComment] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRating();
    // eslint-disable-next-line
  }, [applicationId]);

  const fetchRating = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/applicant-ratings/application/${applicationId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data && response.data.length > 0) {
        setRating(response.data[0].rating);
        setComment(response.data[0].comment || '');
      }
    } catch (err) {
      console.error('Error fetching rating:', err);
    }
  };

  const saveRating = async (newRating) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await api.post(`/api/applicant-ratings/application/${applicationId}`,
        { rating: newRating, comment },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRating(newRating);
      setShowComment(false);
    } catch (err) {
      console.error('Error saving rating:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleStarClick = (value) => {
    if (loading) return;
    if (value === rating) {
      setShowComment(!showComment);
    } else {
      setRating(value);
      saveRating(value);
    }
  };

  return (
    <div className="inline-block">
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((value) => (
          <button
            key={value}
            onClick={() => handleStarClick(value)}
            onMouseEnter={() => setHover(value)}
            onMouseLeave={() => setHover(0)}
            disabled={loading}
            className="cursor-pointer disabled:cursor-wait"
          >
            <Star
              size={size}
              fill={(hover || rating) >= value ? '#fbbf24' : 'none'}
              stroke={(hover || rating) >= value ? '#fbbf24' : '#d1d5db'}
              className="transition-colors"
            />
          </button>
        ))}
      </div>

      {showComment && (
        <div className="mt-2 p-2 border rounded bg-white shadow-lg">
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="w-full border rounded p-2 text-sm"
            rows="3"
            placeholder="Add a comment about this rating..."
          />
          <div className="flex gap-2 mt-2">
            <button
              onClick={() => saveRating(rating)}
              className="text-xs bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
            >
              Save
            </button>
            <button
              onClick={() => setShowComment(false)}
              className="text-xs bg-gray-300 px-3 py-1 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
